import React, { useEffect, useState } from 'react';

import s from './Tooltip.module.css';

interface IProps {
  children: React.ReactNode,
  className?: any,
  tooltip?: string | null,
}

const Tooltip: React.FC<IProps> = ({ children, tooltip, className }) => {
  const [isShownTooltip, setIsShownTooltip] = useState(false);

  const showTooltip = () => setIsShownTooltip(true);
  const hideTooltip = () => setIsShownTooltip(false);

  useEffect(() => {
    document.addEventListener('scroll', hideTooltip);

    return () => {
      document.removeEventListener('scroll', hideTooltip);
    };
  }, []);

  return (
    <>
      <button
        className={className}
        onMouseOver={showTooltip}
        onFocus={showTooltip}
        onMouseLeave={hideTooltip}
        type="button"
      >
        {children}
      </button>
      {isShownTooltip && tooltip && <div className={s.tooltip}>{tooltip}</div>}
    </>
  );
};

export default Tooltip;
